import React from 'react';
import { MicroscopeIcon } from 'lucide-react';
const FullWidthBanner = () => {
  return <div className="w-full bg-gradient-to-r from-teal-50 via-teal-50 to-teal-50 py-16" data-id="element-94" data-mp="27sqdjcre0sop">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-95" data-mp="2cjp20zmj4x31">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-96" data-mp="2ck8ei0teut9o">
          <div className="md:w-1/2" data-id="element-97" data-mp="2gk0jy4nicjat">
            <h2 className="text-3xl font-bold text-teal-800 mb-4" data-id="element-98" data-mp="2gn4sfe80a17a">
              Microbiome Science for Everyone
            </h2>
            <p className="text-lg text-gray-700 mb-6" data-id="element-99" data-mp="1otm9kiepdp3w">
              Our mission is to translate cutting-edge microbiome research into
              practical, accessible solutions that improve gut health and
              overall wellness for all.
            </p>
            <div className="flex items-center gap-4" data-id="element-100" data-mp="1xsg2nystrxcp">
              <div className="w-12 h-1 bg-teal-600 rounded-full" data-id="element-101" data-mp="349uwel3x05uj"></div>
              <p className="text-teal-600 font-medium" data-id="element-102" data-mp="399g4bl12boje">
                Backed by CalMiR Research
              </p>
            </div>
          </div>
          <div className="md:w-1/2 flex justify-center" data-id="element-103" data-mp="1b77f28j63vfe">
            <div className="relative w-64 h-64 flex items-center justify-center" data-id="element-104" data-mp="168cje603qcdv">
              <div className="absolute inset-0 bg-teal-100 rounded-full opacity-30" data-id="element-105" data-mp="119j6ofsn2per"></div>
              <div className="absolute inset-4 bg-teal-200 rounded-full opacity-40" data-id="element-106" data-mp="waq2xf35mcrs"></div>
              <div className="absolute inset-8 bg-teal-300 rounded-full opacity-50" data-id="element-107" data-mp="wd2hrjdm870m"></div>
              <div className="relative bg-white p-6 rounded-full shadow-lg" data-id="element-108" data-mp="sb7kqr2pwfsn">
                <MicroscopeIcon size={80} className="text-teal-600" data-id="element-109" data-mp="ngtm8fsrdsjr" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default FullWidthBanner;